<template>
    <div class="modal fade" id="delete_slider" tabindex="-1">
        <div class="modal-dialog" style="margin-left: 10vw">
            <div class="modal-content" style="width: 80vw">
                <div class="modal-header">
                    <h5 class="modal-title">{{ $lang('Usuń reklamę') }}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    {{ $lang("Czy na pewno chcesz usunąć tę reklamę?") }}
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-default" data-dismiss="modal">
                        {{ $lang('Nie') }}
                    </button>
                    <button @click="deleteSlider(slider.id)" type="button" class="btn btn-primary" :disabled="submitting">
                        {{ $lang('Tak') }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "delete-slider-modal",
    props: {
        delete_url: String,
        slider: Object,
    },
    data () {
        return {
            submitting: false,
        }
    },
    methods: {
        deleteSlider(id) {
            let self = this;
            self.submitting = true;
            axios.post(this.delete_url, {
                id: id
            })
                .then(function () {
                    location.reload();
                })
                .catch(function (error) {
                    console.log(error);
                    self.submitting = false;
                });
        },
    }
}
</script>
